import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "knowledge-base-page";

const keys = addTranslations(RESOURCE_NAME, {
    title: {
        en: "Knowledge Base",
        fr: "Bibliothèque IA",
    },
    subTitle: {
        en: "Control which Ditto data powers your AI. Add additional data to improve AI suggestions.",
        fr: "Contrôlez quelles données Ditto alimentent votre IA. Ajoutez des données supplémentaires pour améliorer les suggestions de l'IA.",
    },
    empty_state_title: {
        en: "No knowledge base items found for this section",
        fr: "Aucune base de connaissances trouvée pour cette section",
    },
    filter_by: {
        en: "Filter by",
        fr: "Filtrer par",
    },
    status: {
        en: "Status",
        fr: "Statut",
    },
    statuses: {
        en: "Statuses",
        fr: "Statuts",
    },
    validated: {
        en: "Validated",
        fr: "Validé",
    },
    inProgress: {
        en: "In Progress",
        fr: "En cours",
    },
    todo: {
        en: "To do",
        fr: "À faire",
    },
    all: {
        en: "All",
        fr: "Tout",
    },
    type: {
        en: "Type",
        fr: "Type",
    },
    types: {
        en: "Types",
        fr: "Types",
    },
    entity: {
        en: "Entity",
        fr: "Entité",
    },
    entities: {
        en: "Entities",
        fr: "Entités",
    },
    policy: {
        en: "Policy",
        fr: "Politique",
    },
    measure: {
        en: "Measure",
        fr: "Mesure",
    },
    edit_document: {
        en: "Edit Custom Documents",
        fr: "Modifier vos Documents spécifiques",
    },
    edit_measure: {
        en: "Edit Measures",
        fr: "Modifier vos Mesures",
    },
    edit_policy: {
        en: "Edit Policies",
        fr: "Modifier vos Politiques",
    },
    edit_framework: {
        en: "Edit Frameworks",
        fr: "Modifier vos Frameworks",
    },
    edit_questionnaire: {
        en: "Edit Questionnaires",
        fr: "Modifier vos Questionnaires",
    },
    edit_objective: {
        en: "Edit Objectives",
        fr: "Modifier vos Objectifs",
    },
    edit_indicator: {
        en: "Edit Indicators",
        fr: "Modifier vos Indicateurs",
    },
    custom_document: {
        en: "Custom Document",
        fr: "Document spécifique",
    },
    add_custom_item: {
        en: "Add Custom Item",
        fr: "Ajouter une information spécifique",
    },
    save_custom_item: {
        en: "Save",
        fr: "Enregistrer",
    },
    cancel: {
        en: "Cancel",
        fr: "Annuler",
    },
    action_bar_enable_ai: {
        en: "Use to power AI",
        fr: "Utiliser pour alimenter l'IA",
    },
    action_bar_disable_ai: {
        en: "Disallow use by AI",
        fr: "Ne pas utiliser pour alimenter l'IA",
    },
    activeGroup: {
        en: "Item selected",
        fr: "Élément sélectionné",
    },
    selected_item: {
        en: "Item selected",
        fr: "Élément sélectionné",
    },
    CUSTOM_ITEM: {
        en: "Custom items",
        fr: "Informations spécifiques",
    },
    activeGroup_CUSTOM_ITEM: {
        en: "Custom item",
        fr: "Information spécifique",
    },
    CUSTOM_ITEM_subtitle: {
        en: "To improve your AI, add relevant information through custom items. By default, all custom items with completed values will be used to power your AI. Adjust your settings below.",
        fr: "Alimentez votre IA avec des informations spécifiques à votre entreprise. Tous les champs remplis sont utilisés par défaut. Vous pouvez paramétrer leur utilisation sur cette page.",
    },
    DOCUMENT: {
        en: "All documents",
        fr: "Documents",
    },
    activeGroup_DOCUMENT: {
        en: "Document",
        fr: "Document",
    },
    DOCUMENT_subtitle: {
        en: "Select which of your documents will power your AI. By default, the latest Approved version of each document will be used to power your AI. Visit the <1>Policies</1>, <2>Measures</2>, and <3>Custom Documents</3> pages to edit, upload, and create documents. ",
        fr: "Choisissez les documents que votre IA doit utiliser. Par défaut, la dernière version Approuvée est prise en compte. Modifiez vos documents sur les pages <1>Politiques</1>, <2>Mesures</2>, et <3>Documents spécifiques</3>.",
    },
    FRAMEWORK: {
        en: "Frameworks",
        fr: "Référentiels",
    },
    activeGroup_FRAMEWORK: {
        en: "Framework",
        fr: "Référentiel",
    },
    FRAMEWORK_subtitle: {
        en: "Select which of your Frameworks will power your AI. By default, your AI will use all of your answers marked Complete in all of your Frameworks. Visit the Frameworks page to manage your Frameworks and edit your answers.",
        fr: "Sélectionnez les Frameworks qui alimenteront votre IA. Par défaut, votre IA utilisera toutes les réponses marquées Complète dans tous vos Frameworks. Visitez la page Frameworks pour gérer vos Frameworks et modifier vos réponses.",
    },
    QUESTIONNAIRE: {
        en: "Questionnaires",
        fr: "Questionnaires",
    },
    activeGroup_QUESTIONNAIRE: {
        en: "Questionnaire",
        fr: "Questionnaire",
    },
    QUESTIONNAIRE_subtitle: {
        en: "Select which of your Questionnaires will power your AI. By default, your AI will use all of your answers marked Complete in all of your Questionnaires. Visit the <1>Questionnaires</1> page to edit your questions and answers.",
        fr: "Choisissez les questionnaires que votre IA utilisera. Tous sont sélectionnés par défaut. L’IA n’utilisera que les réponses de vos questionnaires marquées comme complétées. Pour les modifier, rendez-vous sur la page <1>Questionnaires</1>.",
    },
    INDICATOR: {
        en: "Indicators",
        fr: "Indicateurs",
    },
    activeGroup_INDICATOR: {
        en: "Indicator",
        fr: "Indicateur",
    },
    subtitle: {
        en: "Select which of your Indicators from Reporting will power your AI. By default, your AI will use all of your Indicators. Visit the Reporting page to edit your indicators.",
        fr: "Choisissez les indicateurs que votre IA utilisera. Tous sont sélectionnés par défaut. Pour les modifier, rendez-vous sur la page Reporting.",
    },
    INDICATOR_subtitle: {
        en: "Select which of your Indicators from Reporting will power your AI. By default, your AI will use all of your Indicators. Visit the <1>Reporting</1> page to edit your indicators.",
        fr: "Choisissez les indicateurs que votre IA utilisera. Tous sont sélectionnés par défaut. Pour les modifier, rendez-vous sur la page <1>Reporting</1>.",
    },
    OBJECTIVE: {
        en: "Objectives",
        fr: "Objectifs",
    },
    activeGroup_OBJECTIVE: {
        en: "Objective",
        fr: "Objectif",
    },
    OBJECTIVE_subtitle: {
        en: `Select which of your Objectives will power your AI. By default, your AI will use all of your Objectives. Visit the <1>Objectives</1> page to edit your objectives.`,
        fr: "Choisissez les objectifs que votre IA utilisera. Tous sont sélectionnés par défaut. Pour les modifier, rendez-vous sur la page <1>Objectifs</1>.",
    },
    last_modified_at: {
        en: "Last modified at",
        fr: "Dernière mise à jour",
    },
    POLICY: {
        en: "Policy",
        fr: "Politique",
    },
    MEASURE: {
        en: "Measure",
        fr: "Mesure",
    },
    CUSTOM: {
        en: "Custom Document",
        fr: "Document spécifique",
    },

    TODO: {
        en: "To do",
        fr: "À faire",
    },
    IN_PROGRESS: {
        en: "In Progress",
        fr: "En cours",
    },
    DONE: {
        en: "Validated",
        fr: "Validé",
    },
    link: {
        en: "Link",
        fr: "Lien",
    },
    value: {
        en: "Value",
        fr: "Valeur",
    },
    description: {
        en: "Item Description",
        fr: "Description de l'élément",
    },
    aiVisibilityStatus: {
        en: "Powers AI",
        fr: "Utilisé par l'IA",
    },
    customDocument: {
        en: "Custom Document",
        fr: "Document spécifique",
    },
    dueDate: {
        en: "Due Date",
        fr: "Echéance",
    },
    target: {
        en: "Target",
        fr: "Cible",
    },
    updateKnowledgeBaseSuccess: {
        en: "Knowledge base item updated successfully",
        fr: "Base de connaissances mise à jour avec succès",
    },
    updateKnowledgeBaseError: {
        en: "Failed to update knowledge base item",
        fr: "Erreur lors de la mise à jour de la base de connaissances",
    },
    reset: {
        en: "Reset",
        fr: "Réinitialiser",
    },
    create_custom_item_success: {
        en: "Custom item created successfully",
        fr: "Information spécifique créée avec succès",
    },
    create_custom_item_error: {
        en: "Failed to create custom item",
        fr: "Erreur lors de la création de l'information spécifique",
    },

    custom_item_description: {
        en: "Item description",
        fr: "Description de l'élément",
    },
    custom_item_value: {
        en: "Value",
        fr: "Valeur",
    },
    custom_item_description_error: {
        en: "Description is required",
        fr: "La description est requise",
    },
    update_custom_item_success: {
        en: "Custom item updated successfully",
        fr: "Information spécifique mise à jour avec succès",
    },
    update_custom_item_error: {
        en: "Failed to update custom item",
        fr: "Erreur lors de la mise à jour de l'information spécifique",
    },
    delete_custom_item_success: {
        en: "Custom item deleted successfully",
        fr: "Information spécifique supprimée avec succès",
    },
    delete_custom_item_error: {
        en: "Failed to delete custom item",
        fr: "Erreur lors de la suppression de l'information spécifique",
    },
    no_custom_items: {
        en: "No custom items",
        fr: "Aucune information spécifique",
    },
    add_custom_item_instructions: {
        en: "Add a custom item to improve your AI suggestions",
        fr: "Ajoutez une information spécifique pour améliorer les suggestions de votre IA",
    },
    no_results_found: {
        en: "No results found",
        fr: "Aucun résultat trouvé",
    },
    search_bar_placeholder: {
        en: "Search for a knowledge base item",
        fr: "Rechercher",
    },
    search_bar_placeholder_CUSTOM_ITEM: {
        en: "Search Custom Items",
        fr: "Rechercher",
    },
    search_bar_placeholder_DOCUMENT: {
        en: "Search Documents",
        fr: "Rechercher",
    },
    search_bar_placeholder_INDICATOR: {
        en: "Search Indicators",
        fr: "Rechercher",
    },
    search_bar_placeholder_OBJECTIVE: {
        en: "Search Objectives",
        fr: "Rechercher",
    },
    search_bar_placeholder_QUESTIONNAIRE: {
        en: "Search Questionnaires",
        fr: "Rechercher",
    },
    projectName: {
        en: "Project Name",
        fr: "Nom du projet",
    },
});
export function useKnowledgeBasePageTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
